import { Component, OnInit } from '@angular/core';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import {
  ProductsBiocatchEnum,
  StepBiocatchEnum,
} from 'src/app/shared/enums/biocatchContext.enum';
import { SimulatorModel } from 'src/app/shared/models/abre-cuentas.model';
import { ContactModel } from 'src/app/shared/models/contact.model';
import { DocumentModel } from 'src/app/shared/models/document.model';
import { IProductsModel } from 'src/app/shared/models/products.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { ValidationHelperService } from 'src/app/shared/services/helpers/validation-helper.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { PostValidateService } from 'src/app/shared/services/post-validate/post-validate.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';
import { getAppStatus } from 'single-spa';
import { HelpersService } from 'src/app/shared/services/helpers/helpers-onboarding.service';

import { CryptoVaultService } from 'src/app/shared/services/external/crypto-vault/crypto-vault.service';

@Component({
  selector: 'app-general-information',
  templateUrl: './general-information.component.html',
  styleUrls: ['./general-information.component.scss'],
})
export class GeneralInformationComponent implements OnInit {
  copies: any;
  contactInfo: any;
  productSelected: IProductsModel;
  dataop: any;
  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private abreCuentasService: AbreCuentasService,
    private navigationService: NavigationService,
    private requestService: RequestService,
    private validationHelperService: ValidationHelperService,
    private captureService: CaptureService,
    private postValidate: PostValidateService,
    private biocatchService: BioCatchService,
    private helperService: HelpersService,
    private chiperService: CryptoVaultService,
  ) {
    this.headerService.show(false, false, true);
  }

  async ngOnInit() {
    const status = getAppStatus('simulator');
    status === 'MOUNTED' ? this.helperService.unRegisterAplication('simulator') : console.log();
    console.log('other data');
    console.log(this.abreCuentasService.getOtherSimulationData());
    const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
    const isEvidente = this.biocatchService.isEvidenteCase();
    const isOriginal = product === ProductsBiocatchEnum.VIV && !this.abreCuentasService.getPostlogin() && !this.abreCuentasService.getIsPortal() ? true : false;
    this.biocatchService.changeContext(
      StepBiocatchEnum.captura,
      product,
      isOriginal,
      isEvidente,
    );

    const has_second_headline = this.abreCuentasService.getSecondHeadline();
    this.productSelected = this.abreCuentasService.getproductSelected();
    if (has_second_headline) {
      this.copies = this.copyService.copies.has_second_headline;
    } else {
      console.log('General Information >>>>> \n has_second_headline >>>> ', has_second_headline, '\n Product selected >>> ', this.productSelected);
      await this.postValidate
        .solicitationId()
        .then((res: string) => {
          if (res !== '200') {
            this.navigationService.navigateToGeneralInformation('127');
            return;
          }
        })
        .catch(() =>
          this.navigationService.navigateToGeneralInformation('107'),
        );
      this.copies = this.copyService.copies.general_info_living;
      if (this.productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
        console.log('siks');
        await this.requestService.getSimulationData().then((res: any) => {
          if (res.data === null) {
            this.navigationService.navigateToGeneralInformation('107');
            return;
            // this.dataop = {
            //   "data": {
            //     "data_request": {
            //         "loan": {
            //             "fee": {
            //                 "currency": "COP",
            //                 "amount": 0,
            //                 "decimals": 0
            //             },
            //             "liabilities": null,
            //             "loan_type": "HIP",
            //             "loan_subtype": "52",
            //             "purchase_option": 1,
            //             "flag_capital": false,
            //             "time_limit": 240,
            //             "property_city": "001_5",
            //             "credit_amount": {
            //                 "currency": "COP",
            //                 "amount": 30000000,
            //                 "decimals": 0
            //             },
            //             "property_amount": {
            //                 "currency": "COP",
            //                 "amount": 200000000,
            //                 "decimals": 0
            //             },
            //             "assisted_housing_flag": null,
            //             "new_housing_flag": null,
            //             "financing_type": null,
            //             "own_project_flag": null,
            //             "payoff_amount": null
            //         },
            //         "client": {
            //             "birthdate": "30/07/1990",
            //             "gender": "M",
            //             "email": "correo@gmail.com",
            //             "document": {
            //                 "type": "2",
            //                 "number": "558706",
            //                 "given_names": "Jesus",
            //                 "family_names": "Ferreira",
            //                 "date_of_issue": "01/08/2008"
            //             },
            //             "phone": {
            //                 "phone_number": "3003003003",
            //                 "phone_type": "Mobile"
            //             }
            //         }
            //     },
            //     "data_response": [
            //         {
            //             "fee": {
            //                 "currency": "COP",
            //                 "amount": 447716,
            //                 "decimals": 0
            //             },
            //             "rates": [
            //                 {
            //                     "value": 174,
            //                     "decimals": 1,
            //                     "type": "ea"
            //                 },
            //                 {
            //                     "value": 135,
            //                     "decimals": 2,
            //                     "type": "mv"
            //                 }
            //             ],
            //             "loan_type": "LEA",
            //             "uninsured_fee": {
            //                 "currency": "COP",
            //                 "amount": 421716,
            //                 "decimals": 0
            //             },
            //             "life_insurance": {
            //                 "currency": "COP",
            //                 "amount": 6000,
            //                 "decimals": 0
            //             },
            //             "others_insurances": {
            //                 "currency": "COP",
            //                 "amount": 20000,
            //                 "decimals": 0
            //             },
            //             "purchase_option_amount": {
            //                 "currency": "COP",
            //                 "amount": 300000,
            //                 "decimals": 0
            //             },
            //             "finance_amount": null
            //         },
            //         {
            //             "fee": {
            //                 "currency": "COP",
            //                 "amount": 447885,
            //                 "decimals": 0
            //             },
            //             "rates": [
            //                 {
            //                     "value": 174,
            //                     "decimals": 1,
            //                     "type": "ea"
            //                 },
            //                 {
            //                     "value": 135,
            //                     "decimals": 2,
            //                     "type": "mv"
            //                 }
            //             ],
            //             "loan_type": "HIP",
            //             "uninsured_fee": {
            //                 "currency": "COP",
            //                 "amount": 421885,
            //                 "decimals": 0
            //             },
            //             "life_insurance": {
            //                 "currency": "COP",
            //                 "amount": 6000,
            //                 "decimals": 0
            //             },
            //             "others_insurances": {
            //                 "currency": "COP",
            //                 "amount": 20000,
            //                 "decimals": 0
            //             },
            //             "purchase_option_amount": null,
            //             "finance_amount": null
            //         }
            //     ]
            // }
            // };
            // this.abreCuentasService.setOtherSimulationData({
            //   code: '52',
            //   sub_product: 'HIP',
            //   name: 'Compra de vivienda',
            // });
          } else {
            this.dataop = res;
          }
          const dataSimulation = this.dataop.data.data_request;
          const resultSimulation = this.dataop.data.data_response;
          const name = dataSimulation.client.document.given_names;
          const lastname = dataSimulation.client.document.family_names;
          const names = this.validationHelperService.splitNames(name, lastname);

          this.setContactInfo({
            email: dataSimulation.client.email,
            mobile_number: dataSimulation.client.phone.phone_number,
          });
          this.setDocumentInfo({
            document_number: dataSimulation.client.document.number,
            date_of_issue: dataSimulation.client.document.date_of_issue,
            gender: dataSimulation.client.gender,
            birthdate: dataSimulation.client.birthdate,
            firstname: names.firstname,
            middlename: names.middlename,
            primary_lastname: names.primary_lastname,
            second_lastname: names.second_lastname,
            type: dataSimulation.client.document.type,
          });

          this.setSimulator({
            product_subtype: dataSimulation.loan.loan_type,
            product_subline: dataSimulation.loan.loan_subtype,
            product_name:
              this.abreCuentasService.getOtherSimulationData().name,
            purchase: dataSimulation.loan.purchase_option,
            property_amount: dataSimulation.loan.property_amount,
            term: dataSimulation.loan.time_limit,
            assisted_housing_flag: dataSimulation.loan.assisted_housing_flag,
            new_housing_flag: dataSimulation.loan.new_housing_flag,
            own_project_flag: dataSimulation.loan.own_project_flag,
            liabilities: dataSimulation.loan.liabilities,
            financing_type: dataSimulation.loan.financing_type,
            available_amount: dataSimulation.loan.credit_amount,
            property_city: dataSimulation.loan.property_city,
            fee: dataSimulation.loan.fee,
            leasing_contract: dataSimulation.loan.leasing_contract,
          });
          this.abreCuentasService.getAbreCuentasModel().creditParms = {
            maxAmountValue: dataSimulation.loan.credit_amount.amount,
            maxPeriodValue: dataSimulation.loan.time_limit,
            rateValue: resultSimulation[0].rates[0].value,
          };
        })
          .catch(() => {
            /* console.log(error); */
            this.navigationService.navigateToGeneralInformation('107');
          });
      }
    }
    this.captureService.createContactInfo('PARTICULAR');
  }

  next() {
    this.navigationService.nextStep();
  }

  setContactInfo(data) {
    const contactInfo = data;
    this.contactInfo = new ContactModel();
    this.contactInfo.email = contactInfo.email;
    this.contactInfo.mobile_number = contactInfo.mobile_number;
    this.abreCuentasService.setContactInfo(this.contactInfo);
  }
  setDocumentInfo(data) {
    const documentInfo = new DocumentModel();
    documentInfo.document_number = parseInt(
      data.document_number,
      10,
    ).toString();
    documentInfo.primary_lastname = this.abreCuentasService.converttoPascalCase(
      data.primary_lastname,
    );
    documentInfo.second_lastname = this.abreCuentasService.converttoPascalCase(
      data.second_lastname,
    );
    documentInfo.firstname = this.abreCuentasService.converttoPascalCase(
      data.firstname,
    );
    documentInfo.middlename = this.abreCuentasService.converttoPascalCase(
      data.middlename,
    );
    documentInfo.date_of_issue = data.date_of_issue;
    documentInfo.sex = data.gender;
    documentInfo.birthdate = data.birthdate;
    documentInfo.document_type = data.type;
    this.abreCuentasService.setDocumentInfo(documentInfo);
  }

  setSimulator(data) {
    const simulatorInfo = new SimulatorModel();
    simulatorInfo.product_subtype = data.product_subtype;
    simulatorInfo.product_subline = data.product_subline;
    simulatorInfo.product_name = data.product_name;
    simulatorInfo.purchase = data.purchase;
    simulatorInfo.property_amount = data.property_amount;
    simulatorInfo.term = data.term;
    simulatorInfo.assisted_housing_flag =
      data.assisted_housing_flag === null || data.product.assited === false
        ? false
        : true;
    simulatorInfo.new_housing_flag = data.new_housing_flag ? true : false;
    simulatorInfo.purchase_option = data.purchase ? data.purchase : '0';
    simulatorInfo.own_project_flag = data.own_project_flag ? true : false;
    simulatorInfo.libialities = data.liabilities ? data.liabilities : '';
    simulatorInfo.financing_type = data.financing_type
      ? data.financing_type
      : '';
    simulatorInfo.available_amount = data.available_amount;
    simulatorInfo.city = data.property_city;
    simulatorInfo.fee = data.fee;
    simulatorInfo.leasing_contract = data.leasing_contract;
    this.abreCuentasService.setSimulatorModel(simulatorInfo);
  }
}
